<p [ellipsis]="maxLines" [innerHTML]="description"></p>
